import { Guid } from "guid-typescript";
import { Competition } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "Competition";

/** Competitions a club plays in — the league, cups, friendlies. */
export const CompetitionService = {
	endpoint,
	createSingle: async (data: Competition) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Competition) => await Service.updateSingleById(endpoint, id, data),
}
